import React from 'react';
import MolLink from '../../Basepage/parts/Menu/MolLink';
import { GetEanSearch } from './Componnents/Ean_search';
import './OpenList.scss';

interface OpenListProp {
  data: {
    orderInfoDetails: [];
    eanInfo: any;
  };
  apiBase: string;
}

interface OpenListState {
  storno?: {
    mol_auftrag_id: number;
    mol_auftrag_position_id: number;
    Title: string;
    ean: string;
  };
}

export default class OpenList extends React.Component<
  OpenListProp,
  OpenListState
> {
  constructor(props) {
    super(props);
    this.state = {};
  }
  addMessagePopup() {}
  render(): React.ReactNode {
    let GetEanSearch_local = GetEanSearch(
      '/konto/open',
      this.props.data.eanInfo,
    );
    let GetEanSearch_local_gui = GetEanSearch_local.gui;
    let eanSearchParam = GetEanSearch_local.eanSearchParam;
    let orderInfoDetails = this.props.data.orderInfoDetails ?? [];
    return (
      <div id="OpenList">
        {GetEanSearch_local_gui}
        <div id="messageContainer"></div>
        {this.state.storno != undefined ? (
          <div className="stornoCheck">
            <div className="checkDialog">
              Wollen Sie den Artikel {this.state.storno.Title} mit EAN{' '}
              {this.state.storno.ean} wirklich stornieren
              <br />
              <br />
              <button
                onClick={() => {
                  debugger;

                  let stornoUrl = this.props.apiBase + '/Storno.php';
                  let body = {
                    mol_auftrag_id: this.state.storno?.mol_auftrag_id,
                    mol_auftrag_position_id:
                      this.state.storno?.mol_auftrag_position_id,
                  };
                  let bodyString = JSON.stringify(body);

                  fetch(stornoUrl, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json',
                    },
                    body: bodyString,
                  })
                    .then((res) => res.json())
                    .then(
                      (result) => {
                        window.location.reload();
                        if (result.body.response.storno_state) {
                        } else {
                        }
                      },
                      (error) => {
                        window.location.reload();
                      },
                    );
                }}
              >
                Ja
              </button>
              <br />
              <br />
              <button
                onClick={() => {
                  this.setState({ storno: undefined });
                }}
              >
                Nein
              </button>
            </div>
          </div>
        ) : null}
        <table>
          <thead>
            <tr>
              <th>Datum</th>
              <th>Auftrag ID</th>
              <th>Bestellung ID</th>
              <th>EAN</th>
              <th>Bezeichnung</th>
              <th>Menge</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {orderInfoDetails.map((item: any, index) => {
              let classNameRow = 'row' + (index % 2 == 1 ? ' mod2' : '');

              let link =
                '/konto/mol_orders/' +
                item.mol_auftrag_id +
                '#pos_' +
                item.mol_auftrag_position_id;

              return (
                <tr key={'row_' + item.mol_auftrag_id} className={classNameRow}>
                  <td>{item.date_purchased}</td>
                  <td>
                    <MolLink to={link} href={link}>
                      {item.mol_auftrag_id}
                    </MolLink>
                  </td>
                  <td>{item.bestellreferenz}</td>
                  <td>{item.ean}</td>
                  <td>{item.pos_bezeichnung}</td>
                  <td>
                    {+item.menge - (+item.liefer_menge + +item.storno_menge)}
                  </td>
                  <td>
                    <a
                      className="storno"
                      onClick={() => {
                        this.setState({
                          storno: {
                            mol_auftrag_id: item.mol_auftrag_id,
                            mol_auftrag_position_id:
                              item.mol_auftrag_position_id,
                            Title: item.pos_bezeichnung,
                            ean: item.ean,
                          },
                        });
                      }}
                    >
                      storno anfragen
                    </a>
                  </td>
                  <td>
                    {item.kommisionierung_menge != null &&
                    +item.kommisionierung_menge > 0 ? (
                      <MolLink
                        to="/konto/readyToSend"
                        href="/konto/readyToSend"
                      >
                        Bereit zum Versand
                      </MolLink>
                    ) : (
                      ''
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}
